<script lang="ts">
    import { t } from 'svelte-i18n';
    import bsaCorseLogoImg from '$lib/assets/images/logo-text.png?as=run:0&w=320';
    import dhlLogoImg from '$lib/assets/images/delivery/dhl.png?as=run:0&w=80&format=avif;webp';
    import applePayLogoImg from '$lib/assets/images/payment/apple-pay.png?as=run:0&w=80&format=avif;webp';
    import googlePayLogoImg from '$lib/assets/images/payment/gpay.png?as=run:0&w=80&format=avif;webp';
    import paypalLogoImg from '$lib/assets/images/payment/paypal.png?as=run:0&w=96';
    import visaLogoImg from '$lib/assets/images/payment/cards.png?as=run:0&w=96';
    import klarnaLogoSvg from '$lib/assets/images/payment/klarna.svg';
    import Img from '@zerodevx/svelte-img';
    import IconHeart from '~icons/fa6-solid/heart';
    import ContactForm from '$lib/components/ContactForm.svelte';
    import { useLocaleContext, useStoreContext } from '$lib/context.js';
    import { page } from '$app/stores';
    import LanguageSelection from '$lib/components/LanguageSelection.svelte';

    const lang = useLocaleContext();
    let linkToTermsConditions = $page.route.id?.includes('shop')
        ? '/' + lang + '/terms-conditions-shop'
        : '/' + lang + '/terms-conditions';

    const storeContext = useStoreContext();
</script>

<footer class="container mx-auto px-5 py-12" id="contact">
    <div class="flex flex-col lg:flex-row justify-between lg:gap-x-10">
        <ContactForm />
        <!-- corse div -->
        <div class="w-full lg:w-[50%] space-y-10 mt-16 mb-8">
            <Img src={bsaCorseLogoImg} class="hidden sm:flex" alt="BSA Corse" />

            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                    <h4 class="text-sm sm:text-lg text-[#E5E5E5] uppercase">
                        {$t('website.footer.contact.left.caption')}
                    </h4>
                    <p class="text-xs sm:text-lg text-secondary transition-colors hover:text-lightgrey">
                        {$t('website.footer.contact.left.email')}:
                        <a href="mailto:info@bsa-corse.de">info@bsa-corse.de</a>
                    </p>
                    <p class="text-xs sm:text-lg text-secondary transition-colors hover:text-lightgrey">
                        {$t('website.footer.contact.left.phone')}:
                        <a href="tel:+4906204 92909-0">+49 (0)6204 92909-0</a>
                    </p>
                    <p class="text-xs sm:text-lg text-secondary transition-colors hover:text-lightgrey">
                        {$t('website.footer.contact.left.fax')}:
                        <a href="fax:+4906204 92909-26">+49 (0)6204 92909-26</a>
                    </p>
                </div>
                <div>
                    <h4 class="text-sm sm:text-lg text-[#E5E5E5] uppercase">
                        {$t('website.footer.contact.right.caption')}
                    </h4>
                    <p class="text-xs sm:text-lg text-secondary">{$t('website.footer.contact.right.street')}</p>
                    <p class="text-xs sm:text-lg text-secondary">{$t('website.footer.contact.right.city')}</p>
                    <p class="text-xs sm:text-lg text-secondary">{$t('website.footer.contact.right.country')}</p>
                </div>
                <div>
                    <h4 class="text-sm sm:text-lg text-[#E5E5E5] uppercase">
                        {$t('website.footer.help.caption')}
                    </h4>
                    <p class="text-xs sm:text-lg text-secondary">
                        <a href="/{lang}/shop/shipping-payment" class="transition-colors hover:text-lightgrey"
                            >{$t('website.footer.help.shippingPayment')}</a
                        >
                    </p>
                    <p class="text-xs sm:text-lg text-secondary">
                        <a href="/{lang}/shop/returns-service" class="transition-colors hover:text-lightgrey"
                            >{$t('website.footer.help.returnsService')}</a
                        >
                    </p>
                </div>

                <div>
                    <p class="text-xs sm:text-sm text-secondary">
                        {#if storeContext}
                            {#if storeContext.currentCustomerGroup.displayGross}
                                {$t('shop.page.product.info.pricingInfoInclVat')}
                            {:else}
                                {$t('shop.page.product.info.pricingInfoExclVat')}
                            {/if}
                        {/if}
                    </p>
                    <a
                        href="/{lang}/shop/shipping-payment"
                        class="ml-3 underline text-xs sm:text-sm text-secondary hover:text-lightgrey"
                    >
                        {$t('shop.page.product.info.pricingInfoShipping')}
                    </a>
                </div>

                <!-- <div class="hidden md:block"></div> -->
                <div class="mt-6 md:mt-10">
                    <h4 class="text-sm sm:text-lg text-[#E5E5E5] uppercase mb-2">
                        {$t('website.footer.otherLinks')}
                    </h4>
                    <div class="grid grid-cols-2 gap-2 text-secondary">
                        <a href="https://bsa-corse.com" target="_blank">bsa-corse.com</a>
                        <a href="https://bsa-corse.com" target="_blank">bsa-corse.de</a>
                        <a href="https://bsa-motorsport.de" target="_blank">bsa-motorsport.de</a>
                        <a href="https://bsa-motorsport.com" target="_blank">bsa-motorsport.com</a>
                        <a href="https://brembo-upgrade.de" target="_blank">brembo-upgrade.de</a>
                        <a href="https://bremsen-pista.de" target="_blank">bremsen-pista.de</a>
                        <a href="https://bremsen-gt.de" target="_blank">bremsen-gt.de</a>
                        <a href="https://gt-bremse.de" target="_blank">gt-bremse.de</a>
                        <a href="https://gt-kit.de" target="_blank">gt-kit.de</a>
                        <a href="https://gt-kit.com" target="_blank">gt-kit.com</a>
                        <a href="https://bremse-upgrade.de" target="_blank">bremse-upgrade.de</a>
                        <a href="https://sprintfilter-auto.de" target="_blank">sprintfilter-auto.de</a>
                        <a href="https://sprint-filter.de" target="_blank">sprint-filter.de</a>
                        <a href="https://sprint-filter.eu" target="_blank">sprint-filter.eu</a>
                        <a href="https://sprintfilter-deutschland.de" target="_blank">sprintfilter-deutschland.de</a>
                    </div>
                </div>

                <div>
                    <div class="mt-6 md:mt-10">
                        <h4 class="text-sm sm:text-lg text-[#E5E5E5] uppercase mb-2">
                            {$t('website.footer.shippingPartner')}
                        </h4>
                        <div class="grid grid-cols-2 gap-2">
                            <div class="w-full md:w-24 h-7 bg-[#FFD700] rounded px-2 py-1">
                                <Img src={dhlLogoImg} class="h-full w-full object-contain" alt="DHL" />
                            </div>
                        </div>
                    </div>
                    <div class="md:mt-10">
                        <h4 class="text-sm sm:text-lg text-[#E5E5E5] uppercase mb-2">
                            {$t('website.footer.paymentTypes')}
                        </h4>
                        <div class="grid grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-2">
                            <div class="w-full md:w-24 h-7 bg-[#FFFFFF] rounded overflow-hidden">
                                <Img src={paypalLogoImg} class="h-full w-full object-contain" alt="PayPal" />
                            </div>
                            <div class="w-full md:w-24 h-7 bg-[#FFFFFF] rounded px-2 py-1">
                                <Img src={googlePayLogoImg} class="h-full w-full object-contain" alt="Google Pay" />
                            </div>
                            <div class="w-full md:w-24 h-7 bg-[#FFFFFF] rounded overflow-hidden">
                                <Img src={visaLogoImg} class="h-full w-full object-contain" alt="VISA" />
                            </div>
                            <div class="w-full md:w-24 h-7 bg-[#FFB3C8] rounded px-2 py-1 sm:px-4">
                                <img src={klarnaLogoSvg} class="h-full w-full text-black" alt="Klarna" />
                            </div>
                            <div class="w-full md:w-24 h-7 bg-[#E6E6E6] rounded px-2 py-1">
                                <Img src={applePayLogoImg} class="h-full w-full object-contain" alt="Apple Pay" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- copyright div -->
    <div class="flex flex-col xl:flex-row justify-between text-center sm:text-left space-y-4 sm:space-y-3 xl:space-y-0">
        <p class="text-[#E5E5E5] sm:text-secondary text-sm sm:text-[16px]">
            {@html $t('website.footer.copyright', { values: { year: new Date().getFullYear() } })}
        </p>
        <p class="text-[#E5E5E5] sm:text-secondary text-sm sm:text-[16px]">
            <a class="transition-colors hover:text-lightgrey" href="/{lang}/privacy"
                >{@html $t('website.footer.privacy')}</a
            >
            |
            <a class="transition-colors hover:text-lightgrey" href="/{lang}/imprint"
                >{@html $t('website.footer.imprint')}</a
            >
            |
            <button class="transition-colors hover:text-lightgrey" on:click={() => window.klaro?.show()}
                >{@html $t('website.footer.cookies')}</button
            >
            |
            <a class="transition-colors hover:text-lightgrey" href={linkToTermsConditions}
                >{@html $t('website.footer.termsAndConditions')}</a
            >
            |
            <a class="transition-colors hover:text-lightgrey" href="/{lang}/right-of-revocation"
                >{@html $t('website.footer.rightOfRevocation')}</a
            >
            |
            <!-- Digital withdrawal button (§ 356a BGB): must be permanently available and
                 clearly labelled. Kept as a plain legal link (no loud styling). -->
            <a class="transition-colors hover:text-lightgrey" href="/{lang}/revocation"
                >{@html $t('website.footer.revokeContract')}</a
            >
        </p>
        <div class="flex flex-col lg:flex-row lg:gap-28">
            <div class="mb-6 lg:mb-0">
                <LanguageSelection />
            </div>
            <p class="text-[#E5E5E5] sm:text-secondary text-sm sm:text-[16px]">
                <a
                    href="https://lewo-media.de"
                    rel="external"
                    target="_blank"
                    class="whitespace-nowrap transition-colors hover:text-lightgrey"
                    >Made with
                    <IconHeart class="inline text-primary mx-1 align-text-top" />
                    by LEWO</a
                >
            </p>
        </div>
    </div>
</footer>
